import React from 'react'
import { FieldProps } from '../FormDuuf'

// Formik
import { useFormikContext, FormikContextType } from 'formik'

// Elements
import Label from '../elements/Label'
import Error from '../elements/Error'
import useFormDuuf from '../useFormDuuf'

const ConsentField: React.FC<FieldProps> = ({ formik = {}, hasError = false, fieldId, data }) => {
  const { privacyUrl, privacyUrlPlacement } = useFormDuuf()
  const { handleChange, handleBlur, values }: FormikContextType<{}> = useFormikContext<{}>()
  const type = data.type.toLowerCase()

  return (
    <div className={`form-duuf-group form-duuf-group-${type}`}>
      <Label fieldId={fieldId} data={data} />
      <Error fieldId={fieldId} data={data} hasError={hasError} formik={formik} />
      <div className="d-flex align-items-center">
        <input
          type="checkbox"
          className={`form-duuf-checkbox form-duuf-checkbox-${type}`}
          id={fieldId}
          name={fieldId}
          placeholder={data.placeholder}
          onBlur={handleBlur}
          onChange={(event) => {
            handleChange({
              target: {
                name: event.target.name,
                value: !values[fieldId]
              }
            })
          }}
          value={values[fieldId]}
          checked={values[fieldId]}
        />

        {privacyUrl && (
          <span
            dangerouslySetInnerHTML={{
              __html: `${data.checkboxLabel.replace(
                privacyUrlPlacement ? privacyUrlPlacement : data.checkboxLabel,
                `<a
                target="_blank"
                rel="noreferrer noopener"
                href="${privacyUrl}"
                class="form-duuf-checkbox-label form-duuf-checkbox-${type}"
              >${privacyUrlPlacement ? privacyUrlPlacement : data.checkboxLabel}</a>`
              )}`
            }}
          />
        )}

        {!privacyUrl && (
          <label htmlFor={fieldId} className={`form-duuf-checkbox-label form-duuf-checkbox-${data.type}`}>
            {data.checkboxLabel}
          </label>
        )}
      </div>
    </div>
  )
}

export default ConsentField
